import { Component, OnInit } from '@angular/core';
import { NgZone } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor( private zone: NgZone,
               private router: Router) { }

  ngOnInit() {
  }
  navigate(){
    this.zone.run(()=>this.router.navigate(['home']))
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/errors/page-not-found/page-not-found.component.ts